import React from "react";
import { Tooltip, Typography } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { GRAY_400, WHITE } from "../../constant/colors";

const { Text } = Typography;

export const FilterToolTip = (props) => {
  return (
    <Tooltip
      placement="top"
      title={<Text>{props.title}</Text>}
      id={props.toolTipId ? props.toolTipId : null}
      color={WHITE}
    >
      <QuestionCircleOutlined
        id={props.iconId ? props.iconId : null}
        style={{
          height: "100%",
          color: GRAY_400,
          position: "relative",
          left: props.marginLeft ? props.marginLeft : null,
          cursor: "pointer",
          ...props.iconStyles
        }}
      />
    </Tooltip>
  );
};
